/*
 * custom-product-option-wrapping.js
 * ------------------------------------------------------------------
 * 商品ページの「ラッピングオプション」チェックボックスがONのとき、
 * 本商品とラッピング商品を /cart/add.js に同時POSTする。
 *
 * Splice の <product-form> は form 要素に bubble フェーズで submit
 * ハンドラを登録するため、document の capture フェーズで先取りして
 * stopImmediatePropagation で既存処理をスキップする。
 *
 * 既存ファイル無改修の制約のため、本ファイルは新規追加。
 */
(function () {
  if (window.__customWrappingOptionInit) return;
  window.__customWrappingOptionInit = true;

  var LOG_PREFIX = '[wrapping-option]';

  function getWrappingState(form) {
    // Splice の main-product.liquid では <product-form> が buy-buttons ブロックのみを
    // 包み、custom-liquid ブロック (= 本チェックボックスの配置先) は同じ section 内
    // の別ブロックとして並ぶため、product-form ではなく .shopify-section 全体から
    // チェックボックスを探す必要がある。
    var section = form.closest('.shopify-section') || document.body;
    var el = section.querySelector('.custom-wrapping-option');
    if (!el) return null;

    var checkbox = el.querySelector('.custom-wrapping-option__checkbox');
    if (!checkbox || !checkbox.checked) return null;

    var variantId = el.getAttribute('data-wrapping-variant-id');
    if (!variantId) return null;

    // 状態更新/イベント発火対象は <product-form> 優先、無ければ form 自体
    var productForm = form.closest('product-form') || form;
    return {
      productForm: productForm,
      el: el,
      checkbox: checkbox,
      variantId: variantId,
      productTitle: el.getAttribute('data-product-title'),
      variantTitles: parseVariantTitles(el)
    };
  }

  function parseVariantTitles(el) {
    var script = el.querySelector('script[data-wrapping-variant-titles]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent) || {};
    } catch (e) {
      console.warn(LOG_PREFIX, 'variant titles parse failed', e);
      return {};
    }
  }

  // properties[…] を収集する。form 属性で紐付いたフォーム外 input
  // (納期など) も含めるため querySelectorAll ではなく FormData を使う。
  function getLineItemProperties(form) {
    var properties = {};
    var found = false;
    new FormData(form).forEach(function (value, key) {
      var matched = key.match(/^properties\[(.+)\]$/);
      if (!matched || typeof value !== 'string' || value === '') return;
      properties[matched[1]] = value;
      found = true;
    });
    return found ? properties : null;
  }

  function getMainItem(form) {
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return null;
    var qtyInput = form.querySelector('[name="quantity"]');
    var quantity = 1;
    if (qtyInput && qtyInput.value) {
      var parsed = parseInt(qtyInput.value, 10);
      if (!isNaN(parsed) && parsed > 0) quantity = parsed;
    }
    return { id: idInput.value, quantity: quantity, properties: getLineItemProperties(form) };
  }

  function getCartAddUrl() {
    if (window.theme && window.theme.routes && window.theme.routes.cartAdd) {
      return window.theme.routes.cartAdd;
    }
    return '/cart/add.js';
  }

  function getCartUrl() {
    if (window.theme && window.theme.routes && window.theme.routes.cart) {
      return window.theme.routes.cart;
    }
    return '/cart';
  }

  function setSubmittingState(productForm, isSubmitting) {
    var btn = productForm.querySelector('[name="add"]');
    if (!btn) return;
    if (isSubmitting) {
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('disabled', 'disabled');
      btn.classList.add('is-loading');
    } else {
      btn.removeAttribute('aria-disabled');
      btn.removeAttribute('disabled');
      btn.classList.remove('is-loading');
    }
  }

  function buildSectionsParam() {
    var cartDrawer = document.querySelector('cart-drawer');
    var sections = [];
    if (cartDrawer && cartDrawer.dataset && cartDrawer.dataset.section) {
      sections.push(cartDrawer.dataset.section);
    }
    sections.push('cart-icon-bubble');
    return { cartDrawer: cartDrawer, sections: sections.join(',') };
  }

  async function postBulkAdd(items, sectionsParam) {
    var body = {
      items: items,
      sections: sectionsParam.sections,
      sections_url: window.location.pathname
    };
    console.log(LOG_PREFIX, 'POST', getCartAddUrl(), body);

    var response = await fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    });

    var data = await response.json();
    if (!response.ok) {
      var msg = data && (data.description || data.message);
      var err = new Error(msg || 'カートへの追加に失敗しました。');
      err.detail = data;
      throw err;
    }
    return data;
  }

  function updateCartIconBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    bubble.innerHTML = sections['cart-icon-bubble'];
  }

  function openAndRefreshCartDrawer() {
    // Splice 標準の dispatch イベントで refresh → open。
    // refresh 内で sections を再フェッチして cart-items を更新するため、
    // 自前で data.sections を流し込むより確実。
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
      bubbles: true,
      cancelable: false
    }));
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
      bubbles: true,
      cancelable: false
    }));
  }

  async function verifyCartContains(expectedVariantIds) {
    try {
      var resp = await fetch(getCartUrl() + '.js', { headers: { Accept: 'application/json' } });
      if (!resp.ok) return { ok: false, cart: null, missing: expectedVariantIds.slice() };
      var cart = await resp.json();
      var presentIds = (cart.items || []).map(function (i) { return String(i.variant_id); });
      var missing = expectedVariantIds
        .map(String)
        .filter(function (id) { return presentIds.indexOf(id) === -1; });
      return { ok: missing.length === 0, cart: cart, missing: missing };
    } catch (e) {
      return { ok: false, cart: null, missing: expectedVariantIds.slice(), error: e };
    }
  }

  async function dispatchCartAddEvent(productForm, mainVariantId) {
    try {
      var resp = await fetch(getCartUrl() + '.js');
      var cart = resp.ok ? await resp.json() : null;
      productForm.dispatchEvent(new CustomEvent('on:cart:add', {
        bubbles: true,
        detail: { cart: cart, variantId: mainVariantId, source: 'wrapping-option' }
      }));
    } catch (e) {
      console.warn(LOG_PREFIX, 'cart fetch for on:cart:add failed', e);
    }
  }

  async function handleSubmit(evt) {
    var form = evt.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.classList.contains('js-product-form')) return;
    if (window.location.pathname === getCartUrl()) return;

    var wrapping = getWrappingState(form);
    if (!wrapping) return;

    var main = getMainItem(form);
    if (!main) {
      console.warn(LOG_PREFIX, 'main variant id not found, falling back to default flow');
      return;
    }

    // Splice の <product-form> ハンドラを完全にスキップ
    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

    setSubmittingState(wrapping.productForm, true);

    var sectionsParam = buildSectionsParam();

    try {
      // /cart/add.js (bulk JSON) は items[].id を整数で要求する。
      // attribute / input.value から取得したままだと文字列になり、
      // 環境によっては 422 "Cannot find variant" が返るため変換する。
      var mainIdNum = parseInt(main.id, 10);
      var wrappingIdNum = parseInt(wrapping.variantId, 10);

      if (!Number.isFinite(mainIdNum) || !Number.isFinite(wrappingIdNum)) {
        throw new Error('variant id の整数変換に失敗しました (main=' + main.id + ', wrapping=' + wrapping.variantId + ')');
      }

      // 商品行の「ラッピング: あり」とラッピング行の _wrapping_for で紐付け、カート側で削除を連動させる (custom.js)
      var mainItem = {
        id: mainIdNum,
        quantity: main.quantity,
        properties: Object.assign({}, main.properties, { 'ラッピング': 'あり' })
      };

      var wrappingItem = { id: wrappingIdNum, quantity: 1, properties: { _wrapping_for: String(mainIdNum) } };
      // 同じ商品の別バリエーションを区別できるよう「商品名 / バリエーション名」にする
      var targetLabel = [wrapping.productTitle, wrapping.variantTitles[String(mainIdNum)]].filter(Boolean).join(' / ');
      if (targetLabel) wrappingItem.properties['ラッピング対象'] = targetLabel;

      var items = [mainItem, wrappingItem];

      console.log(LOG_PREFIX, 'sending items', items);
      var data = await postBulkAdd(items, sectionsParam);
      console.log(LOG_PREFIX, 'add response', data);
      console.log(LOG_PREFIX, 'response.items count', (data.items || []).length);

      if (data.sections) {
        updateCartIconBubble(data.sections);
      }

      // カートに両方の商品が実際に入っているか検証
      var verify = await verifyCartContains([mainIdNum, wrappingIdNum]);
      if (!verify.ok) {
        console.warn(LOG_PREFIX, 'CART MISSING ITEMS', {
          requested: [main.id, wrapping.variantId],
          missingVariantIds: verify.missing,
          cartItemCount: verify.cart && verify.cart.item_count,
          cartItems: verify.cart && verify.cart.items
        });
        window.alert(
          'カートへの追加に失敗した可能性があります。\n' +
          '不足している variant_id: ' + verify.missing.join(', ') + '\n' +
          '（DevTools Console に詳細を出力しました）'
        );
      } else {
        console.log(LOG_PREFIX, 'cart verified item_count=', verify.cart && verify.cart.item_count);
      }

      openAndRefreshCartDrawer();

      await dispatchCartAddEvent(wrapping.productForm, main.id);

      // 連続追加でラッピングが再度入らないよう、チェックを外す
      wrapping.checkbox.checked = false;

      // 成功時のボタン演出 (Splice の挙動に合わせる)
      var btn = wrapping.productForm.querySelector('[name="add"]');
      if (btn) {
        btn.classList.add('is-success');
        btn.removeAttribute('aria-disabled');
        setTimeout(function () {
          btn.classList.remove('is-loading');
          btn.classList.remove('is-success');
          btn.removeAttribute('disabled');
        }, 2000);
      }
    } catch (err) {
      console.error(LOG_PREFIX, err, err && err.detail);

      var message = (err && err.message) || 'カートへの追加に失敗しました。';

      wrapping.productForm.dispatchEvent(new CustomEvent('on:cart:error', {
        bubbles: true,
        detail: { error: message, source: 'wrapping-option' }
      }));

      window.alert(message);
      setSubmittingState(wrapping.productForm, false);
    }
  }

  document.addEventListener('submit', handleSubmit, true);

  /*
   * a11y ワークアラウンド:
   * Splice の SideDrawer.close() は aria-hidden="true" を先に立ててから
   * フォーカスを外すため、閉じるボタンにフォーカスがある状態だと
   * Chrome が "Blocked aria-hidden ... descendant retained focus" 警告を出す。
   * before-close イベントは aria-hidden 設定より前に発火するので、
   * ここで内部のフォーカスを抜いておく。
   */
  document.addEventListener('on:cart-drawer:before-close', function (evt) {
    var drawer = evt.target;
    if (!drawer || typeof drawer.contains !== 'function') return;
    var active = document.activeElement;
    if (active && active !== document.body && drawer.contains(active) && typeof active.blur === 'function') {
      active.blur();
    }
  });
})();
